import axiosInstance from "./AxiosInstance"

export function createLeadOtherinfo(otherInfoData) {
  return axiosInstance.post("/lead/addLeadOtherInformation", otherInfoData)
}
